import { useEffect, useState } from "react";
import Select from "react-select";
import Header from "../../Components/comman/Header";
import Searchbar from "../../Components/comman/Searchbar";
import { Form, Offcanvas } from "react-bootstrap";
import ThemeButtom from "../../Components/ThemeButtom";
import MobileHeader from "../../Components/comman/MobileHeader";
import Aos from "aos";
import { useDebounce } from "../../Helpers/useDebounce";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import { Link } from "react-router-dom";
import CustomLoader from "../../Components/comman/Loader/CustomLoader";
import { MdOutlineFilterAlt } from "react-icons/md";

const CollaborationHub = () => {
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#f4f4f8",
      backgroundColor: "#f4f4f8",
      fontWeight: "bold",
      maxHeight: "200px",
      overflow: "hidden",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "180px",
      overflowY: "auto",
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      fontWeight: "bold",
      backgroundColor: state.isSelected ? "#afd7d1" : "#f4f4f8",
      color: state.isSelected ? "#000000" : "#575757",
      borderBottom: "1px solid #ccc",
      "&:last-child": {
        borderBottom: "none",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontWeight: "bold",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "bold",
      color: "#575757",
    }),
    input: (provided) => ({
      ...provided,
      fontWeight: "bold",
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#189f8e" : provided.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px #189f8e" : provided.boxShadow,
      "&:hover": {
        borderColor: state.isFocused
          ? "#189f8e"
          : provided["&:hover"].borderColor,
      },
    }),
  };
  const [widgetShow, setWidgetShow] = useState(false);
  const widgetClose = () => setWidgetShow(false);
  const handleWidgetShow = () => setWidgetShow(true);
  const [data, setData] = useState([]);
  const [filterDataValue, setFilterDataValue] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  // const [filters, setTempFilters] = useState({});
  const [tempFilters, setTempFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});

  useEffect(() => {
    Aos.init({});
  }, []);

  const handleSearch = (searchValue) => {
    setSearch(searchValue);
  };
  const getCollaborationsData = () => {
    setIsLoading(true);
    let config = {
      url: ApiUrl.collaborationHubFilter,
      method: "POST",
      body: {
        ...appliedFilters,
        search: debouncedSearch,
      },
    };
    APIRequest(
      config,
      (res) => {
        const fetchedData = res?.data?.data || [];
        console.log("fetch", fetchedData);
        setData(fetchedData);
        filterLocalData(fetchedData, debouncedSearch);
        setIsLoading(false);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
        setData([]);
        setFilteredData([]);
      }
    );
  };
  const filterLocalData = (dataToFilter, searchText) => {
    if (!searchText.trim()) {
      setFilteredData(dataToFilter);
      return;
    }
    const searchLower = searchText.toLowerCase();
    const filtered = dataToFilter.filter((item) => {
      return (
        (item?.brand?.company_name?.toLowerCase() || "").includes(
          searchLower
        ) ||
        (item?.campaign_title?.toLowerCase() || "").includes(searchLower) ||
        (item?.campaign_description?.toLowerCase() || "").includes(
          searchLower
        ) ||
        (item?.niche?.toLowerCase() || "").includes(searchLower) ||
        item?.countries?.some((country) =>
          country?.name?.toLowerCase().includes(searchLower)
        ) ||
        item?.campaign_platform?.some((platform) =>
          platform?.platform_name?.toLowerCase().includes(searchLower)
        )
      );
    });
    setFilteredData(filtered);
  };
  const onApply = () => {
    widgetClose();
    setAppliedFilters(tempFilters);
  };
  const getFilterData = () => {
    let config = {
      url: ApiUrl.collaborationHubFilterName,
      method: "GET",
    };
    APIRequest(
      config,
      (res) => {
        setFilterDataValue(res?.data);
        setIsLoading(false);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    getCollaborationsData();
  }, [appliedFilters, debouncedSearch]);

  const resetAll = () => {
    setTempFilters({});
    setAppliedFilters({});
    setSearch("");
    widgetClose();
    setResetKey((prev) => prev + 1);
  };

  useEffect(() => {
    getFilterData();
    getCollaborationsData();
  }, []);
  return (
    <div className="collaboration-wrapper">
      <Header />
      <MobileHeader />
      <Offcanvas
        className="mobile-collab-filter-canvas"
        show={widgetShow}
        onHide={widgetClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="collaboration-wrapper mobile-filter-collab">
            <div className="collab-inner">
              <div className="collab-left">
                <div className="refine-box">
                  <h5>Refine Search</h5>
                  <Select
                    key={`sort-${resetKey}`}
                    className="filter-select"
                    options={filterDataValue?.sorting_types}
                    placeholder={"Newest Campaign"}
                    styles={customStyles}
                    onChange={(e) =>
                      setTempFilters((p) => ({ ...p, sort: e?.value }))
                    }
                  />
                  <Select
                    key={`brand-${resetKey}`}
                    className="filter-select"
                    options={filterDataValue?.brands}
                    placeholder={"Brands"}
                    styles={customStyles}
                    onChange={(e) =>
                      setTempFilters((p) => ({ ...p, brand_id: e?.value }))
                    }
                  />
                  {/* <div key={"checkbox"} className="mb-3">
              <Form.Check
                type={"Checkbox"}
                label={"Only paid campaigns"}
                className="filter-checkbox"
                onChange={(e) =>
                  setTempFilters((p) => ({ ...p, only_paid: e.target.checked }))
                }
              />
            </div> */}
                </div>
                <div className="deliverables-box">
                  <h4>deliverables</h4>
                  <Select
                    key={`Platforms-${resetKey}`}
                    options={filterDataValue?.campaign_platform}
                    placeholder={"Platforms"}
                    styles={customStyles}
                    onChange={(e) =>
                      setTempFilters((p) => ({
                        ...p,
                        social_platform_id: e?.value,
                      }))
                    }
                  />
                  <Select
                    key={`Strategy-${resetKey}`}
                    options={filterDataValue?.strategies}
                    placeholder={"Strategy"}
                    styles={customStyles}
                    onChange={(e) =>
                      setTempFilters((p) => ({
                        ...p,
                        strategy_ids: [e?.value],
                      }))
                    }
                  />
                  <Select
                    key={`Content-${resetKey}`}
                    options={filterDataValue?.content_formats}
                    placeholder={"Content Type"}
                    styles={customStyles}
                    onChange={(e) =>
                      setTempFilters((p) => ({
                        ...p,
                        content_types: [e?.value],
                      }))
                    }
                  />
                </div>
                <div className="qualifications-box">
                  <h4>Qualifications</h4>
                  <p>
                    Select social platform above to set follower & engagement
                    criteria.
                  </p>
                  <Select
                    key={`Gender-${resetKey}`}
                    options={filterDataValue?.genders}
                    placeholder={"Gender"}
                    styles={customStyles}
                    onChange={(e) =>
                      setTempFilters((p) => ({ ...p, gender: e?.value }))
                    }
                  />
                  <Select
                    key={`Country-${resetKey}`}
                    options={filterDataValue?.countries}
                    placeholder={"Country"}
                    styles={customStyles}
                    onChange={(e) =>
                      setTempFilters((p) => ({ ...p, country_id: e?.value }))
                    }
                  />
                  <Select
                    key={`Niche-${resetKey}`}
                    options={filterDataValue?.categories}
                    placeholder={"Niche"}
                    styles={customStyles}
                    onChange={(e) =>
                      setTempFilters((p) => ({ ...p, category_id: e?.value }))
                    }
                  />
                </div>
                <div className="collab-btn-box">
                  <ThemeButtom title={"Apply Filters"} handleClick={onApply} />
                  <button className="outlined-btn" onClick={resetAll}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <div className="collab-inner">
        <div className="collab-left">
          <div className="refine-box">
            <h5>Refine Search</h5>
            <Select
              key={`sort-${resetKey}`}
              className="filter-select"
              options={filterDataValue?.sorting_types}
              placeholder={"Newest Campaign"}
              styles={customStyles}
              onChange={(e) =>
                setTempFilters((p) => ({ ...p, sort: e?.value }))
              }
            />
            <Select
              key={`brand-${resetKey}`}
              className="filter-select"
              options={filterDataValue?.brands}
              placeholder={"Brands"}
              styles={customStyles}
              onChange={(e) =>
                setTempFilters((p) => ({ ...p, brand_id: e?.value }))
              }
            />
            {/* <div key={"checkbox"} className="mb-3">
              <Form.Check
                type={"Checkbox"}
                label={"Only paid campaigns"}
                className="filter-checkbox"
                onChange={(e) =>
                  setTempFilters((p) => ({ ...p, only_paid: e.target.checked }))
                }
              />
            </div> */}
          </div>
          <div className="deliverables-box">
            <h4>deliverables</h4>
            <Select
              key={`Platforms-${resetKey}`}
              options={filterDataValue?.campaign_platform}
              placeholder={"Platforms"}
              styles={customStyles}
              onChange={(e) =>
                setTempFilters((p) => ({
                  ...p,
                  social_platform_id: e?.value,
                }))
              }
            />
            <Select
              key={`Strategy-${resetKey}`}
              options={filterDataValue?.strategies}
              placeholder={"Strategy"}
              styles={customStyles}
              onChange={(e) =>
                setTempFilters((p) => ({
                  ...p,
                  strategy_ids: [e?.value],
                }))
              }
            />
            <Select
              key={`Content-${resetKey}`}
              options={filterDataValue?.content_formats}
              placeholder={"Content Type"}
              styles={customStyles}
              onChange={(e) =>
                setTempFilters((p) => ({
                  ...p,
                  content_types: [e?.value],
                }))
              }
            />
          </div>
          <div className="qualifications-box">
            <h4>Qualifications</h4>
            <p>
              Select social platform above to set follower & engagement
              criteria.
            </p>
            <Select
              key={`Gender-${resetKey}`}
              options={filterDataValue?.genders}
              placeholder={"Gender"}
              styles={customStyles}
              onChange={(e) =>
                setTempFilters((p) => ({ ...p, gender: e?.value }))
              }
            />
            <Select
              key={`Country-${resetKey}`}
              options={filterDataValue?.countries}
              placeholder={"Country"}
              styles={customStyles}
              onChange={(e) =>
                setTempFilters((p) => ({ ...p, country_id: e?.value }))
              }
            />
            <Select
              key={`Niche-${resetKey}`}
              options={filterDataValue?.categories}
              placeholder={"Niche"}
              styles={customStyles}
              onChange={(e) =>
                setTempFilters((p) => ({ ...p, category_id: e?.value }))
              }
            />
          </div>
          <div className="collab-btn-box">
            <ThemeButtom title={"Apply Filters"} handleClick={onApply} />
            <button className="outlined-btn" onClick={resetAll}>
              Reset
            </button>
          </div>
        </div>

        <div className="collab-right">
          <div className="collab-header-wrapper">
            <div className="collab-right-content">
              <p className="title">Collaboration Hub</p>
              <p>
                Explore endless partnership opportunities - from paid campaigns
                to giveaways and affiliate programs. Opt in to campaigns you're
                interested in and track your progress!
              </p>
              <Searchbar onSearch={handleSearch} />
            </div>
          </div>
          <a
            className="mobile-collab-filter-wrapper"
            onClick={handleWidgetShow}
          >
            <MdOutlineFilterAlt />
            <p>Filters</p>
          </a>
          <div className="collab-boxes-main-wrapper">
            {isLoading ? (
              <CustomLoader visible={isLoading} />
            ) : (
              <>
                {filteredData.length > 0 ? (
                  <div className="wish-featured-box">
                    {filteredData.map((item, index) => (
                      <Link
                        to="/campagin-detail"
                        state={{ product: item, from: "Collab" }}
                        className="collab-product-box"
                        key={index}
                        data-aos="fade-up"
                        data-aos-duration="1000"
                      >
                        <div className="collab-product-box-img">
                          <img
                            src={item?.campaign_logo_url || "/default-logo.png"}
                            alt="product"
                          />
                        </div>
                        <div className="collab-product-box-content">
                          <div className="heading">
                            <h6 className="product-name">
                              {item?.brand?.company_name}
                            </h6>
                            <p className="p-title">{item?.campaign_title}</p>
                          </div>

                          <div className="list-wrapper">
                            {item?.campaign_platform?.length > 0 && (
                              <>
                                <div className="list-name">
                                  <span>Followers</span>
                                  <span className="title">
                                    {item.campaign_platform[0]
                                      ?.social_engagement_data?.follower ||
                                      "N/A"}
                                    +
                                  </span>
                                </div>

                                <div className="list-name">
                                  <span>Engagement</span>
                                  <span className="title">
                                    {item.campaign_platform[0]
                                      ?.social_engagement_data?.engagement ||
                                      "N/A"}
                                    % +
                                  </span>
                                </div>
                              </>
                            )}

                            <div className="list-name">
                              <span>Age</span>
                              <span className="title">
                                {item?.age?.min || "N/A"}-
                                {item?.age?.max || "N/A"}+
                              </span>
                            </div>
                            <div className="list-name">
                              <span>Residence</span>
                              <div className="countryFlagBox">
                                {item?.countries?.map((country, idx) => (
                                  <img
                                    className="countryFlag"
                                    key={idx}
                                    src={
                                      country?.flag_url || "/default-flag.png"
                                    }
                                    alt={country?.name || "Country flag"}
                                    title={country?.name}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                          <Link
                            to="/campagin-detail"
                            state={{ product: item, from: "featured" }}
                          >
                            <button className="niche-btn">View Details</button>
                          </Link>
                        </div>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className="no-results-message">
                    No collaborations found {search && `for "${search}"`}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CollaborationHub;
